import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { PrintService } from '../../services/print.service';

@Component({
  selector: 'ng-hbm-bdi-image-zoom',
  templateUrl: './image-zoom.component.html'
})
export class ImageZoomComponent implements OnInit {

  public dlLoading: boolean;
  public printLoading: boolean;
  public imgSrc: string;

  constructor(public modalService: ModalService, private printService: PrintService) {
    this.imgSrc = modalService.currentDatas.imgUrl;
  }

  ngOnInit(): void { }

  print(): void {
    this.printLoading = true;
    this.printService.reset();
    this.printService.addHeader("").then(() => {
      this.printService.addImage(this.imgSrc).then(() => {
        this.printService.print();
        this.printLoading = false;
      });
    });
  }

  download(): void {
    this.dlLoading = true;
    let _filename = this.imgSrc.split("/").pop().split("?").shift();
    let xhr = new XMLHttpRequest();
    xhr.open("GET", this.imgSrc, true);
    xhr.responseType = "blob";
    xhr.onload = (e: any) => {
      let link = document.createElement("a");
      if (link.download !== undefined) { // feature detection
        // Browsers that support HTML5 download attribute
        let url = URL.createObjectURL(xhr.response);
        link.setAttribute("href", url);
        link.setAttribute("download", _filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.dlLoading = false;
      }
    }
    xhr.send();
  }
}
